import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import { ColorButton, IconTooltip } from 'components';
import { annotationColors } from '../../constants';

const useStyles = makeStyles((theme) => {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      listStyleType: 'none',
    },
  };
});

const ColorButtons = ({
  children,
  className,
  disabled,
  handleColorSelection,
  hasError = false,
  selectedColor,
  firstButtonRef,
  ariaDescribedby,
  ...props
}) => {
  const classes = useStyles();
  const colorList = [
    { button: 'gold', highlight: 'yellow' },
    { button: 'lime', highlight: 'green' },
    { button: 'orange', highlight: 'red' },
    { button: 'purple', highlight: 'blue' },
  ];

  const isCurrentColor = (color) => {
    return selectedColor === color;
  };

  return (
    <ul className={clsx(classes.root, className)} {...props}>
      {colorList.map((color, index) => (
        <IconTooltip
          id={`color-button-${color.button}`}
          placement="top"
          title={annotationColors[color.highlight]}
          key={`${color.button}-tooltip-key`}
        >
          <li>
            <ColorButton
              aria-label={`Select a ${
                annotationColors[color.highlight]
              } highlight`}
              color={color.button}
              isChecked={isCurrentColor(color.highlight)}
              onClick={() => handleColorSelection(color.highlight)}
              shouldUseActionRef={true}
              {...(index === 0 ? { ref: firstButtonRef, hasError } : {})}
              {...(ariaDescribedby
                ? { 'aria-describedby': ariaDescribedby }
                : {})}
            />
          </li>
        </IconTooltip>
      ))}
    </ul>
  );
};

ColorButtons.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Should the button have error state UI
   */
  hasError: PropTypes.bool,
};

export default ColorButtons;
